import z from "zod";

import { dateSchema } from './utils';

const subscriptionBaseSchema = z.object({
  amount: z.string(),
  canceled_at: dateSchema.nullable().catch(null),
  card_type: z.string(),
  description: z.string(),
  id: z.string(),
  is_active_for_premium: z.boolean(),
  last_four: z.string().nullable(),
  legacy: z.boolean(),
  next_billing_date: z.string().nullable(),
  plan_id: z.string(),
  tax_amount: z.string(),
});

const cryptoSubscriptionSchema = subscriptionBaseSchema.extend({
  payment_gateway: z.literal("crypto_dot_com"),
  status: z.enum(["active", "canceled", "expired", "pending", "trial"]),
});

const braintreeSubscriptionSchema = subscriptionBaseSchema.extend({
  payment_gateway: z.literal("braintree_payments"),
  status: z.enum(["active", "canceled", "expired", "past_due", "trial"]),
});

const legacyMoovSubscriptionSchema = subscriptionBaseSchema.extend({
  payment_gateway: z.literal("legacy_moov"),
  status: z.enum(["active"]),
});

const subscriptionSchema = z.discriminatedUnion("payment_gateway", [
  cryptoSubscriptionSchema,
  braintreeSubscriptionSchema,
  legacyMoovSubscriptionSchema,
]);

type Subscription = z.infer<typeof subscriptionSchema>;

export {
  subscriptionSchema,
  cryptoSubscriptionSchema,
  braintreeSubscriptionSchema,
  legacyMoovSubscriptionSchema,
  type Subscription,
};
